

export class TagWordModel {
    public Id: number;
    public Name: string;
    public AccountId: Number;
}



// WEBPACK FOOTER //
// ./src/app/models/tagWordModel.ts